import { Institution } from '@tempus/trials-types';
import { AxiosResponse } from 'axios';

import { UserSiteMap } from '~/store/site/types';

import axios from '../axios';
import { TRIALS_API_ROOT } from '../constants';

export const timeSitesApi = {
  getAll: async (): Promise<AxiosResponse<{ data: Institution[] }>> => {
    return axios.get(`${TRIALS_API_ROOT}/institutions`, {
      params: {
        attributes: 'id,name,shortName',
        overrideLimit: true,
        'programBehaviors->TIME': 'site',
      },
    });
  },
  getTrialArmSites: async (trialId: string, armId?: string): Promise<{ timeSites: Institution[] }> => {
    return axios
      .get(`${TRIALS_API_ROOT}/v1/institutions/time-sites/trial/${trialId}`, {
        params: armId ? { armId } : {},
      })
      .then(({ data }) => data);
  },
  getUserSites: async (): Promise<UserSiteMap> => {
    return axios.get(`${TRIALS_API_ROOT}/v1/institutions/sites/user`).then(({ data }) => data);
  },
};
